module.exports = __webpack_public_path__ + "img/step2-fr.f7e64303.webp";